module.exports = __webpack_public_path__ + "static/media/487.7b2b2f7e.gif";